import script from "./CustomSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomSelect.vue?vue&type=script&lang=ts&setup=true"

import "./CustomSelect.vue?vue&type=style&index=0&id=466c4219&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466c4219"]])

export default __exports__